import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const exportDashboardToPDF = async (dashboardRef, title = "Revenue Performance Report") => {
  const element = dashboardRef.current;
  if (!element) return;

  // Configuration for high-quality capture
  const canvas = await html2canvas(element, {
    scale: 3, // Increases resolution
    useCORS: true,
    logging: false,
    backgroundColor: '#f8fafc', // Matches your dashboard slate-50 background
    windowWidth: element.scrollWidth, // Capture full width
    windowHeight: element.scrollHeight // Capture full height
  });

  const imgData = canvas.toDataURL('image/png');
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'px',
    format: [canvas.width / 2, canvas.height / 2] // Maintains aspect ratio
  });

  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

  pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  pdf.save(`${title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};